import { createSlice } from '@reduxjs/toolkit';
import {
  UpdateCompanyProfile,
  GetCompanyProfileById,
  GetCompanyImagesById,
  updateAndAddImagesById,
  DeleteCompanyImagesById,
} from 'redux/services/CompanyService';

export const CompanySlice = createSlice({
  name: 'dropdown',
  initialState: {
    CmyProfileList: [],
    getCmyProfile: '',
    updateCompanyDetails: '',
    getCmyImages: '',
    updateImages: '',
  },
  reducers: {
    CompanyProfileList: (state, action) => {
      state.CmyProfileList = [action.payload];
    },
    getCompanyProfile: (state, action) => {
      state.getCmyProfile = [action.payload];
    },
    getCompanyImages: (state, action) => {
      state.getCmyImages = [action.payload];
    },
    updateCompanyImages: (state, action) => {
      state.updateImages = [action.payload];
    },
  },
});

export const updateCompanyList = (payload) => async () => {
  return UpdateCompanyProfile(payload)
};

export const getCompanyProfileByuserId = (username) => async (dispatch) => {
  GetCompanyProfileById(username).then((response) => {
    dispatch(getCompanyProfile(response.data));
  });
};

export const getCompanyImagesList = (username) => async (dispatch) => {
  GetCompanyImagesById(username).then((response) => {
    dispatch(getCompanyImages(response.data));
  });
};

export const updateAndAddImages = (data, type) => async () => {
  return updateAndAddImagesById(data, type);
};

export const DeleteCmyImages = (data, attachment) => async () => {
  return DeleteCompanyImagesById(data, attachment);
};

export const {
  CompanyProfileList,
  getCompanyProfile,
  getCompanyImages,
  updateCompanyImages,
} = CompanySlice.actions;
export default CompanySlice.reducer;
